<template>
    <button class="theme-toggle" @click="toggleTheme" :title="isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'">
        <i :class="[isDarkMode ? 'bi bi-sun-fill' : 'bi bi-moon-fill']"></i>
    </button>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useTheme } from "@/composables/useTheme";

export default defineComponent({
    name: "ThemeToggle",
    props: {
        isDarkNav: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const { isDarkMode, toggleTheme } = useTheme();

        return {
            isDarkMode,
            toggleTheme,
        };
    },
});
</script>

<style scoped>
.theme-toggle {
    background: none;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    width: 32px;
    height: 32px;
}

/* Light navigation context */
.theme-toggle:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

/* Dark navigation context */
.theme-toggle.dark-nav:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.theme-toggle i {
    font-size: 1.2rem;
}
</style> 